<template>
    <div v-if="isVisible" class="loader-overlay">
        <!-- <div class="loader"></div> -->
        <img  class="text"  src="../../public/assets/layout/images/Logo_Branco_Estado_MT.png" style="width: 13%;"><br>
        <div class="lds-ellipsis">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div> 
        <span class="msg" v-html="text"></span>
    </div>
</template>

<script>
export default {
    
    name: "Loader",
    props: {
        isVisible: {type: Boolean, required: true},
        text: {type: String, required: false, default: "Carregando"},
    },
}
</script>

<style>
    .loader-overlay {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.7);
        z-index: 9999;
        cursor: pointer;
    
    }       
     .loader-overlay .text {
        display: inline-block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        color: #fff;
    }          
     .loader-overlay .msg {
        display: inline-block;
        position: absolute;
        top: 57%;
        left: 50%;
        transform: translate(-50%,-50%);
        color: #fff;
        font-weight: bold;
    }
    .lds-ellipsis {
        display: inline-block;
        position: absolute;
        width: 4%;
        height: 8%;
        top: 50%;
        left: 41%;
    }
        .lds-ellipsis div {
        position: absolute;
        top: 33px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #fff;
        animation-timing-function: cubic-bezier(0, 1, 1, 0);
    }
    .lds-ellipsis div:nth-child(1) {
        left: 8px;
        animation: lds-ellipsis1 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(2) {
        left: 8px;
        animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(3) {
        left: 32px;
        animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(4) {
        left: 56px;
        animation: lds-ellipsis3 0.6s infinite;
    }
    @keyframes lds-ellipsis1 {
        0% {
            transform: scale(0);
        }
        100% {
            transform: scale(1);
        }
    }
    @keyframes lds-ellipsis3 {
        0% {
         transform: scale(1);
        }
        100% {
            transform: scale(0);
        }
    }
    @keyframes lds-ellipsis2 {
        0% {
            transform: translate(0, 0);
        }
        100% {
            transform: translate(24px, 0);
        }
    }   

    @media (min-width: 37em) { /* 592px */
     .loader-overlay .msg {
            display: inline-block;
            position: absolute;
            top: 58%;
            left: 50%;
            transform: translate(-50%,-50%);
            color: #fff;
            font-size: 12px;
            font-weight: bold;
        }    
        .lds-ellipsis {
            display: inline-block;
            position: absolute;
            width: 4%;
            height: 8%;
            top: 52%;
            left: 43.9%;
        }
        .lds-ellipsis div {
            position: absolute;
            top: 33px;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: #fff;
            animation-timing-function: cubic-bezier(0, 1, 1, 0);
        }
    }
    @media (min-width: 41em) { /* 656px */
     .loader-overlay .msg {
            display: inline-block;
            position: absolute;
            top: 58%;
            left: 50%;
            transform: translate(-50%,-50%);
            color: #fff;
            font-size: 12px;
            font-weight: bold;
        }    
        .lds-ellipsis {
            display: inline-block;
            position: absolute;
            width: 4%;
            height: 8%;
            top: 52%;
            left: 45%;
        }
        .lds-ellipsis div {
            position: absolute;
            top: 33px;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: #fff;
            animation-timing-function: cubic-bezier(0, 1, 1, 0);
        }
    }
    @media (min-width: 47em) { /* 752px */
    
        .loader-overlay .msg {
            display: inline-block;
            position: absolute;
            top: 71%;
            left: 50.3%;
            transform: translate(-50%,-50%);
            color: #fff;
            font-weight: bold;
        }    
        .lds-ellipsis {
            display: inline-block;
            position: absolute;
            width: 4%;
            height: 8%;
            top: 56%;
            left: 45.4%;
        }
        .lds-ellipsis div {
            position: absolute;
            top: 33px;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: #fff;
            animation-timing-function: cubic-bezier(0, 1, 1, 0);
        }
    }
    @media (min-width: 68em) {  /* 1088px */
        .loader-overlay .msg {
            display: inline-block;
            position: absolute;
            top: 63%;
            left: 50%;
            transform: translate(-50%,-50%);
            color: #fff;
            font-weight: bold;
        }    
        .lds-ellipsis {
            display: inline-block;
            position: absolute;
            width: 4%;
            height: 8%;
            top: 56%;
            left: 47%;
        }
     }
    @media (min-width: 82em) { /* 1312px */
        .loader-overlay .msg {
            display: inline-block;
            position: absolute;
            top: 64%;
            left: 50%;
            transform: translate(-50%,-50%);
            color: #fff;
            font-size: 15px;
            font-weight: bold;
        }    
        .lds-ellipsis {
            display: inline-block;
            position: absolute;
            width: 4%;
            height: 8%;
            top: 57%;
            left: 47.3%;
        }
    }
    @media (min-width: 100em){ /* 1600px */
        .loader-overlay .msg {
            display: inline-block;
            position: absolute;
            top: 65%;
            left: 50%;
            transform: translate(-50%,-50%);
            color: #fff;
            font-size: 15px;
            font-weight: bold;
        }    
        .lds-ellipsis {
            display: inline-block;
            position: absolute;
            width: 4%;
            height: 8%;
            top: 58%;
            left: 47.7%;
        }
    }
    @media (min-width: 115em){ /* 1840px */
        .loader-overlay .msg {
            display: inline-block;
            position: absolute;
            top: 67%;
            left: 50%;
            transform: translate(-50%,-50%);
            color: #fff;
            font-size: 15px;
            font-weight: bold;
        }    
        .lds-ellipsis {
            display: inline-block;
            position: absolute;
            width: 4%;
            height: 8%;
            top: 60%;
            left: 48.1%;
        }
    }


</style>